// Module
var code = `<div class="alert alert-info">
  <div class="alert__label"><strong>PLEASE NOTE:</strong></div>
  <div class="alert__description">
    Watchlist file must follow certain rules like column names, and their order.
    Please check example file for the reference.
    For individuals columns are interpreted as 'First name', 'Last name', 'Middle name'.
    For corporate only 'Business name' is taken into account.
    Replacing a file will result in removing all previously added entries.
  </div>
</div>

<breadcrumbs></breadcrumbs>

<section id="watchlist-details" class="box">
  <sub-header header="\$ctrl.watchlist.name || 'Create New'"></sub-header>

  <div class="tab-content">
    <form name="\$ctrl.form">
      <div class="form-section">
        <form-section form-title="'Watchlist:'">
          <form-section-field field-title="'Name:'">
            <input
              type="text"
              placeholder="Name"
              required
              ng-model="\$ctrl.watchlist.name"
              ng-minlength="1"
              ng-maxlength="64"/>
          </form-section-field>

          <form-section-field field-title="'Watchlist type:'">
            <select
              required
              ng-change="\$ctrl.onWatchlistTypeChange()"
              ng-model="\$ctrl.watchlist.watchlistType"
              ng-options="type.value as type.label for type in \$ctrl.watchlistTypes"
            >
            </select>
          </form-section-field>

          <form-section-field field-title="'Customer type:'">
            <select
              ng-disabled="\$ctrl.watchlist.watchlistType === 'SANCTIONED_ENTITY'"
              required
              ng-model="\$ctrl.watchlist.customerType"
              ng-options="type.value as type.label for type in \$ctrl.availableCustomerTypes"
            >
            </select>
          </form-section-field>

          <form-section-field field-title="'File:'">
            <div class="file-upload">
              <file-upload ng-model="\$ctrl.uploadedFiles"
                           validate-uploaded
                           max-files="1"
                           name="documentUpload"
                           validate="{pattern: '.xls,*.xlsx'}"
                           show-file-name="true"
                           show-remarks="false"
                           allow-duplicates="true"
                           enable-webcam="false"
              >
              </file-upload>
              <button class="btn btn-success pull-right"
                      type="button"
                      ng-click="\$ctrl.downloadExampleXls()">
                Download example
              </button>
            </div>
          </form-section-field>
        </form-section>
      </div>
    </form>

    <div class="clearfix"></div>

    <div class="buttons">
      <button class="btn btn-primary"
              ng-if="!\$ctrl.watchlist.id"
              command-access="CreateWatchlist"
              ng-disabled="\$ctrl.isMainSaveDisabled()"
              ng-click="\$ctrl.createWatchlist()">
        Create
      </button>
      <button class="btn btn-success"
              ng-if="\$ctrl.watchlist.id && \$ctrl.watchlist.entries"
              ng-click="\$ctrl.downloadXls()">
        Download xls
      </button>
      <button class="btn btn-primary"
              ng-if="\$ctrl.watchlist.id"
              command-access="UpdateWatchlist"
              ng-disabled="\$ctrl.isMainSaveDisabled()"
              ng-click="\$ctrl.saveWatchlist()">
        Save
      </button>
      <button class="btn btn-warning"
              ng-click="\$ctrl.goBack()">
        Cancel
      </button>
    </div>

    <div class="clearfix"></div>

    <form-section form-title="'Search:'"
                  ng-if="\$ctrl.watchlist.id && \$ctrl.watchlist.entries">
      <form-section-field field-title="'Name:'">
        <input
          type="text"
          placeholder="Name"
          ng-model="\$ctrl.searchName"
          ng-change="\$ctrl.onSearchChange()"
          ng-minlength="1"
          ng-maxlength="64"/>
      </form-section-field>
    </form-section>

    <br/>

    <table class="table table-style table-hover watchlist-entry__table"
           ng-if="\$ctrl.watchlist.id && \$ctrl.watchlist.entries">
      <thead>
      <tr>
        <th>Ref no</th>
        <th>Name 1</th>
        <th>Name 2</th>
        <th>Name 3</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="entry in \$ctrl.matchingEntries track by \$index"
          ng-form
          name="\$ctrl['form_' + \$index]">
        <td>
          <input type="text"
                 required
                 ng-disabled="entry.id"
                 ng-model="entry.refNo"/>
        </td>
        <td>
          <input type="text"
                 class="watchlist-entry__name"
                 required
                 ng-disabled="!entry.isEdit"
                 ng-model="entry.name1"/>
        </td>
        <td>
          <input type="text"
                 class="watchlist-entry__name"
                 ng-disabled="!entry.isEdit"
                 ng-model="entry.name2"/>
        </td>
        <td>
          <input type="text"
                 class="watchlist-entry__name"
                 ng-disabled="!entry.isEdit"
                 ng-model="entry.name3"/>
        </td>
        <td>
          <form-section ng-if="entry.isEdit">
            <form-section-field field-title="'Name 4:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name4"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 5:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name5"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 6:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name6"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 7:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name7"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 8:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name8"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 9:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name9"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 10:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name10"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 11:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name11"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 12:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name12"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 13:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name13"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 14:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name14"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
            <form-section-field field-title="'Name 15:'">
              <input
                type="text"
                class="watchlist-entry__name"
                ng-disabled="!entry.isEdit"
                ng-model="entry.name15"
                ng-minlength="1"
                ng-maxlength="64"/>
            </form-section-field>
          </form-section>
        </td>
        <td>
          <button class="btn btn-primary"
                  ng-if="!entry.id"
                  command-access="CreateWatchlistEntry"
                  ng-disabled="\$ctrl.isSaveDisabled(\$index)"
                  ng-click="\$ctrl.createEntry(\$index)">
            Create
          </button>
          <button type="button"
                  class="btn btn-warning"
                  ng-if="entry.isEdit"
                  ng-click="\$ctrl.cancelEntry(\$index)">
            Cancel
          </button>
          <button class="btn btn-warning"
                  ng-if="entry.id && !entry.isEdit"
                  command-access="UpdateWatchlistEntry"
                  ng-click="\$ctrl.editEntry(\$index)">
            Edit
          </button>
          <button class="btn btn-primary"
                  ng-if="entry.id && entry.isEdit"
                  command-access="UpdateWatchlistEntry"
                  ng-disabled="\$ctrl.isSaveDisabled(\$index)"
                  ng-click="\$ctrl.updateEntry(\$index)">
            Save
          </button>
          <button type="button"
                  class="btn btn-danger"
                  ng-if="entry.id && !entry.isEdit"
                  command-access="DeleteWatchlistEntry"
                  ng-click="\$ctrl.removeEntry(\$index)">
            Delete
          </button>
        </td>
      </tr>
      </tbody>
      <tfoot class="watchlist-entry__table--footer">
      <tr id="entry--new">
        <td colspan="5"></td>
        <td>
          <button class="btn btn-success watchlist-entry__button"
                  type="button"
                  command-access="CreateWatchlistEntry"
                  ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.watchlist.id"
                  ng-click="\$ctrl.addEntry()">
            Add new
          </button>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/watchlist/watchlist-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;